<template>
  <div class="form-group" :class="{ 'input-group': hasIcon }">
    <slot name="label">
      <label v-if="label" class="control-label">
        {{ labelKey | setText(label) }} <info v-if="info" :id="info" />
        <span v-if="labelLang">({{ labelLang }}) </span>
        <span
          v-if="type === 'password'"
          @click="showPassword = !showPassword"
          class="link"
        >
          <span v-if="showPassword">{{ "hide" | setText("скрыть") }}</span>
          <span v-else>{{ "show" | setText("показать") }}</span>
        </span>
      </label>
      <label v-if="title" class="control-label">
        {{ titleKey | setText(title) }}
      </label>
    </slot>
    <slot name="addonLeft">
      <span v-if="addonLeftIcon" class="input-group-prepend">
        <i :class="addonLeftIcon" class="input-group-text"></i>
      </span>
    </slot>
    <input
      :value="value"
      @input="$emit('input', $event.target.value)"
      v-bind="$attrs"
      class="form-control"
      :type="!showPassword ? (type ? type : 'text') : 'text'"
      aria-describedby="addon-right addon-left"
    />
    <slot></slot>
    <slot name="addonRight">
      <span v-if="addonRightIcon" class="input-group-append">
        <i :class="addonRightIcon" class="input-group-text"></i>
      </span>
    </slot>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPassword: false,
    };
  },
  inheritAttrs: false,
  name: "fg-input",
  props: {
    label: String,
    info: Number,
    title: String,
    titleKey: String,
    type: String,
    labelLang: String,
    labelKey: String,
    k: String,
    value: [String, Number],
    addonRightIcon: String,
    addonLeftIcon: String,
  },
  computed: {
    hasIcon() {
      const { addonRight, addonLeft } = this.$slots;
      return (
        addonRight !== undefined ||
        addonLeft !== undefined ||
        this.addonRightIcon !== undefined ||
        this.addonLeftIcon !== undefined
      );
    },
  },
};
</script>
<style>
</style>
